// ==================================================================================
// CUSTOM GOOGLE ADS CONVERSION TRACKING SCRIPT
// ==================================================================================

// Initialize dataLayer and gtag
window.dataLayer = window.dataLayer || [];

if (typeof window.gtag === 'undefined') {
  window.gtag = function() {
    window.dataLayer.push(arguments);
  };
  
  if (!document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=AW-430325841';
    document.head.appendChild(script);
  }
  
  window.gtag('js', new Date());
  window.gtag('config', 'AW-430325841');
}

// ==================================================================================
// PURCHASE EVENT HANDLER
// ==================================================================================

window.addEventListener("breeze-purchase", (event) => {
  if (!event.detail || !event.detail.data) {
    console.error("❌ Purchase event: Invalid event data - missing detail or data");
    return;
  }
  
  breezePurchase(event.detail);
});

function breezePurchase(payload) {
  try {
    merchantPurchaseCustomCode(payload.data);
  } catch (e) {
    console.error("❌ Error in breezePurchase:", e);
    console.error("Stack:", e.stack);
  }
}

function merchantPurchaseCustomCode(params) {
  const ga4Items = createGTagItems(params.items);
  const gA4UserData = createGA4Userdata(params.userDetails);
  
  const conversionPayload = {
    send_to: ["AW-430325841/HC8HCLWf7fgBENGAmc0B"],
    developer_id: {
      dNzYwYj: true
    },
    transaction_id: params.shopOrderId,
    value: params.totalPrice,
    google_analysis_params: {
      lineItemValue: ga4Items.reduce((sum, item) => sum + item.price * item.quantity, 0),
      totalPriceValue: params.totalPrice
    },
    currency: "INR",
    tax: params.tax || 0,
    shipping: params.shipping || 0,
    items: ga4Items,
    userData: gA4UserData,
    customer_type: params.customerType,
    payment_type: params.paymentMethodType,
    breeze_event_type: 'breeze_purchase'
  };
  
  window.gtag("event", "purchase", conversionPayload);
}

// ==================================================================================
// BEGIN CHECKOUT EVENT HANDLER
// ==================================================================================

window.addEventListener("breeze-initiate-checkout", (event) => {
  if (!event.detail || !event.detail.data) {
    console.error("❌ Checkout event: Invalid event data - missing detail or data");
    return;
  }
  
  breezeBeginCheckout(event.detail);
});

function breezeBeginCheckout(payload) {
  try {
    merchantBeginCheckoutCustomCode(payload.data);
  } catch (e) {
    console.error("❌ Error in breezeBeginCheckout:", e);
    console.error("Stack:", e.stack);
  }
}

function merchantBeginCheckoutCustomCode(params) {
  const ga4Items = createGTagItems(params.items);
  const gA4UserData = createGA4Userdata(params.userDetails);
  
  const conversionPayload = {
    send_to: ["AW-430325841/PmjJCL6f7fgBENGAmc0B"],
    developer_id: {
      dNzYwYj: true
    },
    ecomm_prodid: ga4Items.map((item) => item.id),
    ecomm_totalvalue: params.totalPrice,
    ecomm_pagetype: 'cart',
    value: params.totalPrice,
    google_analysis_params: {
      lineItemValue: ga4Items.reduce((sum, item) => sum + item.price * item.quantity, 0),
      totalPriceValue: params.totalPrice
    },
    currency: "INR",
    items: ga4Items,
    userData: gA4UserData
  };
  
  window.gtag("event", "begin_checkout", conversionPayload);
}

// ==================================================================================
// ADD PAYMENT INFO EVENT HANDLER
// ==================================================================================

window.addEventListener("breeze-add-payment-info", (event) => {
  if (!event.detail || !event.detail.data) {
    console.error("❌ Checkout event: Invalid event data - missing detail or data");
    return;
  }
  
  breezeAddPaymentInfo(event.detail);
});

function breezeAddPaymentInfo(payload) {
  try {
    merchantAddPaymentInfoCustomCode(payload.data);
  } catch (e) {
    console.error("❌ Error in breezeAddPaymentInfo:", e);
    console.error("Stack:", e.stack);
  }
}

function merchantAddPaymentInfoCustomCode(params) {
  const ga4Items = createGTagItems(params.items);
  const gA4UserData = createGA4Userdata(params.userDetails);
  
  const conversionPayload = {
    send_to: ["AW-430325841/ooMzCMSf7fgBENGAmc0B"],
    developer_id: {
      dNzYwYj: true
    },
    currency: "INR",
    total: params.totalPrice,
    items: ga4Items,
    userData: gA4UserData,
    value: params.totalPrice,
  };
  
  window.gtag("event", "add_payment_info", conversionPayload);
}

// ==================================================================================
// UTILITY FUNCTIONS
// ==================================================================================

function createGTagItems(items) {
  if (!items || !Array.isArray(items)) {
    console.error("❌ createGTagItems: invalid items array:", items);
    return [];
  }
  
  return items.map(item => decodeGA4Items(item));
}

function decodeGA4Items(item) {
  const itemId = 'shopify_IN_' + String(item.id) + '_' + String(item.variant);
  return {
    id: itemId,
    name: item.name,
    brand: item.vendor,
    category: item.productType,
    coupon: item.discount || '',
    price: item.price,
    quantity: item.quantity,
    variant: item.variantTitle || ''
  };
}

function createGA4Userdata(userData) {
  if (!userData) {
    return null;
  }
  
  const ga4Address = {
    first_name: userData.firstName || userData.name || '',
    last_name: userData.lastName || '',
    street: userData.address || '',
    city: userData.city || '',
    region: userData.state || '',
    postal_code: userData.postalCode || '',
    country: 'IN'
  };
  
  return {
    email: userData.email || '',
    phone_number: userData.phone || '',
    address: ga4Address
  };
}